import {isNullOrUndefined} from "../../../../services/Validator";
import FlashResultsGraphCard from "../../../cards/courses/flash/FlashResultsGraphCard";
import FlashResultsScoreCard from "../../../cards/courses/flash/FlashResultsScoreCard";

export default function FlashResultsTabletSummary({scores, total}) {
    // Used in FlashResultsScreen to display flash score summary
    // in tablet mode

    // BUILD
    if (isNullOrUndefined(scores) && isNullOrUndefined(total))
        return null;
    return (
        <div className={"w-full hidden sm:flex lg:hidden space-x-24 mt-24"}>
            <FlashResultsScoreCard scores={scores} total={total} />
            <FlashResultsGraphCard scores={scores} />
        </div>
    );
}